// Ai sửa được đơn qua `PUT /orders/:id` — gương của `canPatchOrder` ở
// backend/internal/core/order/handler.go: quyền `order.write`, HOẶC phòng lễ
// tân / marketing với vai qua được cửa ghi theo phòng. CSKH sửa đơn qua danh
// sách ô hẹp riêng nên KHÔNG tính ở đây.
//
// Một gương cho mọi nút gọi cửa sửa đơn mà người dùng thường là lễ tân (nối đơn
// vào hồ sơ khách, khai số người trang điểm ngay trong khối chia việc) — hỏi
// riêng `order.write` là giấu nút với đúng người hay bấm nó nhất, vì vai
// `staff` phòng lễ tân không mang quyền đó mà máy chủ vẫn cho qua.

import { ACTION } from "@/lib/auth/actions";
import { deptWriteDoorClosed } from "@/lib/auth/dept-door";
import { usePermission } from "@/lib/authv2/permissions";
import { useAuthV2 } from "@/lib/authv2/store";

const PATCH_DEPTS = new Set(["reception", "marketing"]);

export function canPatchOrder(
  hasOrderWrite: boolean,
  staff: { role?: string | null; department?: string | null } | null,
): boolean {
  if (hasOrderWrite) return true;
  if (!staff) return false;
  const dept = (staff.department ?? "").trim().toLowerCase();
  return PATCH_DEPTS.has(dept) && !deptWriteDoorClosed(staff.role);
}

export function useCanPatchOrder(): boolean {
  const hasOrderWrite = usePermission(ACTION.OrderWrite);
  const staff = useAuthV2((s) => s.currentStaff);
  return canPatchOrder(hasOrderWrite, staff);
}
